import React from 'react';
import transformTemplateData from 'utils/transformTemplateData';
import ContentfulSection from 'components/Contentful/ContentfulSection';
import { getArrayOfEntries } from './utils/entriesHelpers';
import { getWireProps, getCtaCardsProps } from './utils/getLayoutProps';
import ComponentMap from './ComponentMap';
import { ReactLazyComponent } from '../ComponentMap';

const ContentfulLayout = (props) => {
  const { templateName, unusedIds } = props;

  let entries;

  const Component = ComponentMap[templateName];

  if (Component) {
    let componentProps;
    entries = getArrayOfEntries(props);

    if (templateName === 'Call To Action Cards') {
      componentProps = getCtaCardsProps(entries);
    }

    if (templateName === 'Dynamic Wire') {
      componentProps = getWireProps(entries);
    }

    if (templateName === 'Spade') {
      componentProps = { type: props?.options?.Variation };
    }

    return (
      <ReactLazyComponent>
        <Component entries={entries} {...props} {...componentProps} />
      </ReactLazyComponent>
    );
  }

  const data = transformTemplateData(props, unusedIds);

  return (
    <ContentfulSection
      {...data}
      variation={props?.options?.Variation}
      className={props?.className || ''}
    />
  );
};

export default ContentfulLayout;
